import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { SsoRedirectionComponent } from './sso-redirection/sso-redirection.component';

import { LandingComponent } from './landing/landing.component';
import { AppRoutingModule } from '../app-routing.module';

import { InboundSsoComponent } from './inbound-sso/inbound-sso.component';



@NgModule({
    imports: [
    CommonModule,
    AppRoutingModule,
    HeaderComponent,
    FooterComponent,
    NavBarComponent,
    SsoRedirectionComponent,
    InboundSsoComponent,
    LandingComponent
],
    exports: [
        HeaderComponent,
        FooterComponent,
        NavBarComponent,
        SsoRedirectionComponent,
        LandingComponent
    ]
})
export class CoreModule {

  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule has already been loaded. You should only import Core modules in the AppModule only.');
    }
  }

}
